<div class="chip-button-select">
    <mat-select multiple class="chip-button-select-desktop"
        [ngClass]="{'chip-button-stretch' : stretch}"
        [disableRipple]="true"
        [hideSingleSelectionIndicator]="true"
        [panelClass]="isMobile && !disableBottomSheet ? 'scss-disable-panel' : 'scss-chip-button-select'"
        [value]="[true]"
        (closed)="SelectClosed()"
        (click)="SelectClicked($event)">
        <mat-select-trigger>
            <ng-container *ngTemplateOutlet="triggerTemplate"></ng-container>
        </mat-select-trigger>
        @for (item of itemList; track item.itemQueryList; let ind = $index) {
            @if (item.itemQueryList.length > 1) {
                <mat-option
                    class="scss-disable-mat-selected"
                    [value]="true"
                    (click)="SelectAll(item, ind, !item.form.controls.SelectAll.value)">
                    <lib-checkbox
                        [formControl]="item.form.controls.SelectAll"
                        [isIndeterminate]="item.isIndeterminate"
                        [checked]="item.isAllSelected"
                        (change)="SelectAll(item, ind, $event)">
                        {{item.selectAllLabel}}
                        ({{item.itemQueryList.length}})
                    </lib-checkbox>
                </mat-option>
            }
            @for (checkbox of item.itemQueryList; track checkbox.value; let i = $index) {
                <mat-option
                    class="scss-disable-mat-selected"
                    [value]="checkbox.value"
                    (click)="ChangeEvent(item, ind, !item.viewControl.controls[i].value, i)">
                    <lib-checkbox [ngClass]="{'padding-left-28': item.itemQueryList.length > 1}"
                        [formControl]="item.viewControl.controls[i]"
                        [checked]="item.viewControl.controls[i].value"
                        [isLoading]="item.isLoading"
                        [qaTag]="checkbox.qaTag"
                        (change)="ChangeEvent(item, ind, $event, i)">
                        <ng-container *ngTemplateOutlet="checkbox.label"></ng-container>
                    </lib-checkbox>
                </mat-option>
            }
        }
    </mat-select>
</div>
